export default [
  {
    name: 'superadmin_massive_import_details',
    path: '/customers/massive_import/:id',
    meta: {
      section: 'customers',
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_COMMERCIAL']
    },
    component: () =>
      import(
        /* webpackChunkName: 'sadmin-massive-import' */ '@/modules/customers/_views/massive_import/MassiveImportDetails'
      )
  },
  // {
  //   path: '/signup',
  //   name: 'customer-signup',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "customer-signup" */ '../_views/signup/CustomerSelfOnboarding'
  //     ),
  //   meta: {
  //     layout: 'blank',
  //     isPublic: true
  //   }
  // },
  {
    path: '/activate/:token',
    name: 'customer-activation',
    component: () =>
      import(
        /* webpackChunkName: "customer-activaton" */ '../_views/signup/ActivateCustomer'
      ),
    meta: {
      layout: 'blank',
      isPublic: true
    }
  },
  {
    path: '/customers',
    name: 'customers',
    component: () =>
      import(
        /* webpackChunkName: 'customers' */ '@/modules/customers/_views/Index'
      ),
    redirect: { name: 'active_customers' },
    children: [
      {
        name: 'active_customers',
        path: 'active',
        meta: {
          section: 'customers',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_COMMERCIAL']
        },
        component: () =>
          import(
            /* webpackChunkName: 'active-customers' */ '@/modules/customers/_views/active/CustomerList'
          )
      },
      {
        name: 'superadmin_users',
        path: 'users',
        meta: {
          section: 'customers',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_COMMERCIAL']
        },
        component: () =>
          import(
            /* webpackChunkName: 'sadmin-users' */ '@/modules/customers/_views/active/UsersList'
          )
      }

    ]
  }
]
